import { Team } from './Team';

export const enablingAndPlatformTeams: Team[] = [
  {
    name: 'AppSec',
    entityRef: 'group:default/appsec',
  },
  {
    name: 'EDS Core',
    entityRef: 'group:default/eds-core',
  },
  {
    name: 'Omnia Solum',
    entityRef: 'group:default/omnia-solum',
  },
  {
    name: 'Power Platform',
    entityRef: 'group:default/dcs-power-platform-team',
  },
  {
    name: 'Radix',
    entityRef: 'group:default/team-radix',
  },
  {
    name: 'Varia',
    entityRef: 'group:default/varia-team',
  },
];
